import { createFileRoute } from "@tanstack/react-router";
import { AiPage } from "../features/ai/AiPage";

// Deliberately outside the /w/$ws tree: the chat with TANK's own model belongs to the
// person, not to a workspace. `?c=` names the open conversation so a link lands on it.
export const Route = createFileRoute("/ai")({
  validateSearch: (s: Record<string, unknown>): { c?: string } =>
    typeof s.c === "string" && s.c ? { c: s.c } : {},
  component: AiPage,
});
